import { currentUserState, useAppSelector } from '@state';

import { type AppRole } from '../auth/roles';

export const useAppRoles = (): Array<AppRole> => {
	const currentUser = useAppSelector(currentUserState);
	if (!currentUser) return [];
	return (currentUser.appRoles ?? []) as Array<AppRole>;
};

export const useCapabilities = (): Array<string> => {
	const currentUser = useAppSelector(currentUserState);
	if (!currentUser) return [];
	return currentUser.capabilities ?? [];
};

export const useAuthorize = (capability: string): boolean => {
	const capabilities = useCapabilities();
	return capabilities.includes(capability);
};
